import Layout from "@/components/feature/Layout";
import Seo from "@/components/feature/Seo";
import PageBreadcrumb from "@/components/feature/PageBreadcrumb";
import { authors, formatViews } from "@/mocks/comics";

export default function Authors() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: "/" },
          { "@type": "ListItem", position: 2, name: "作者专区" },
        ],
      },
      {
        "@type": "CollectionPage",
        name: "漫蛙漫画网作者专区",
        inLanguage: "zh-CN",
      },
    ],
  };

  return (
    <Layout>
      <Seo
        title="漫蛙漫画网作者专区 | 认识连载漫画背后的创作者"
        description="漫蛙漫画网作者专区集中展示签约作者的创作风格、简介与系列作品，帮你快速追踪心仪作者的每一部连载漫画，建立完整的追更清单。"
        keywords="漫蛙漫画网作者专区,漫画家,连载漫画作者,系列漫画"
        jsonLd={jsonLd}
      />

      <div className="bg-background-100">
        <div className="mx-auto max-w-7xl px-4 pb-8 pt-24 md:px-6 md:pt-28">
          <PageBreadcrumb items={[{ label: "首页", to: "/" }, { label: "作者专区" }]} />
          <h1 className="mt-4 font-heading text-2xl font-extrabold tracking-tight text-foreground-950 md:text-3xl">
            作者专区
          </h1>
          <p className="mt-2 max-w-2xl text-sm text-foreground-500">
            每一位创作者都是漫蛙漫画网的灵魂。浏览作者简介、创作风格与系列作品，轻松追踪心仪作者的全部连载更新。
          </p>
        </div>
      </div>

      <section className="bg-background-50 py-10 md:py-14">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-6 px-4 md:grid-cols-2 md:px-6">
          {authors.map((a) => (
            <article
              key={a.id}
              className="flex flex-col gap-5 rounded-2xl bg-background-100 p-6 ring-1 ring-background-200 sm:flex-row"
            >
              <div className="mx-auto h-28 w-28 shrink-0 overflow-hidden rounded-2xl ring-2 ring-primary-200 sm:mx-0">
                <img
                  src={a.avatar}
                  alt={`漫画家 ${a.name} 头像`}
                  title={`${a.name} 作者专区`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1 text-center sm:text-left">
                <div className="flex flex-col items-center gap-2 sm:flex-row sm:justify-between">
                  <h2 className="font-heading text-xl font-extrabold text-foreground-950">{a.name}</h2>
                  <span className="flex items-center gap-1 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-700">
                    <i className="ri-heart-3-fill" aria-hidden="true" />
                    {formatViews(a.followers)} 人关注
                  </span>
                </div>
                <p className="mt-1 text-sm italic text-primary-700">「{a.signature}」</p>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{a.intro}</p>
                <div className="mt-4 flex flex-wrap justify-center gap-1.5 sm:justify-start">
                  {a.works.map((t) => (
                    <span key={t} className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
    </Layout>
  );
}